/* eslint-disable */
/**
 * 移动端适配公共常量与工具方法
 */

// 手机端布局断点，与 App.vue 的设备判断、styles/mobile.less 的媒体查询保持一致
export const MOBILE_MAX_WIDTH = 768;

/**
 * 判断当前是否手机端宽度（不依赖 Vue 实例，供非组件代码使用）
 */
export function isMobileWidth() {
    return typeof window !== 'undefined' && window.innerWidth <= MOBILE_MAX_WIDTH;
}

/**
 * 金额格式化：1234.5 -> 1,234.50
 */
export function formatMoney(v) {
    return Number(v || 0).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

/**
 * 数字缩写：12345 -> 1.2万，便于手机端窄栏展示
 */
export function formatShortNumber(v) {
    const n = Number(v || 0);
    if (Math.abs(n) >= 100000000) return (n / 100000000).toFixed(1) + '亿';
    if (Math.abs(n) >= 10000) return (n / 10000).toFixed(1) + '万';
    return String(n);
}

/**
 * 相对时间：2024-01-01 -> 3天前
 */
export function formatTimeAgo(d) {
    if (!d) return '—';
    const t = new Date(d).getTime();
    if (isNaN(t)) return '—';
    const days = Math.floor((Date.now() - t) / 86400000);
    if (days <= 0) return '今天';
    if (days === 1) return '昨天';
    if (days < 30) return `${days}天前`;
    if (days < 365) return `${Math.floor(days / 30)}个月前`;
    return `${Math.floor(days / 365)}年前`;
}

export default {
    MOBILE_MAX_WIDTH,
    isMobileWidth,
    formatMoney,
    formatShortNumber,
    formatTimeAgo,
};
